import React from 'react';

import {Trans} from '../../../libs/shared/helpers/src/internationalization/react';

export function renderDraftLabel(
  hasAutoShareDrafts: boolean,
  isInDraftsFolder: boolean,
  isVisuallyShared: boolean,
) {
  if (hasAutoShareDrafts) {
    if (isInDraftsFolder) {
      return isVisuallyShared ? (
        <Trans id="celldraft-shared">Shared</Trans>
      ) : (
        <Trans id="celldraft-personal">Personal</Trans>
      );
    }

    return <Trans id="celldraft-draft">Draft</Trans>;
  }

  return isVisuallyShared ? (
    <Trans id="cell-shareddraft">Shared draft</Trans>
  ) : (
    <Trans id="cell-draft">Draft</Trans>
  );
}
